import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer className='bg-dark pb-2 pt-5 text-grey'>
                <div className='container'>

                    <div className='row my-4'>

                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <p className='footer-heading'>About Company</p>
                            <p className=''>We Delivery high-quality custom software/ website solutions in Prayagraj that meet every client needs and deliver long-term value.</p>
                            <span onClick={() => window.open('https://www.linkedin.com/company/dectwin-services/?viewAsMember=true', '_blank')}><i class="fa-brands my-2 about-icon fa-linkedin-in"></i></span>
                            <span className='ms-2' onClick={() => window.open('https://www.instagram.com/dectwinservices/', '_blank')}><i class="fa-brands my-2 about-icon fa-instagram"></i></span>
                        </div>

                        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-2'>
                            <p className='footer-heading'>Address</p>
                            <p><i class="fa-solid fa-headset"></i> 8707510135<br /><br />
                                <i class="fa-solid fa-envelope-open-text"></i> contact@dectwinservices.com<br /><br />
                                <i class="fa-solid fa-map-location-dot"></i> 85/47, CY Chintamani Rd, Darbhanga Colony, George Town, Prayagraj, Uttar Pradesh 211002</p>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <p className='footer-heading'>Quick Links</p>
                            <Link className='footer-link' to='/'><i class="fa-solid fa-angle-right me-2"></i>Home</Link><br />
                            <Link className='footer-link' to='/about'><i class="fa-solid fa-angle-right me-2"></i>About</Link><br />
                            <Link className='footer-link' to='/services'><i class="fa-solid fa-angle-right me-2"></i>Services</Link><br />
                            <Link className='footer-link' to='/contact'><i class="fa-solid fa-angle-right me-2"></i>Contact</Link><br />
                            <Link className='footer-link' to='/billing-software'><i class="fa-solid fa-angle-right me-2"></i>Billing Software</Link><br />
                            <Link className='footer-link' to='/hotel-management'><i class="fa-solid fa-angle-right me-2"></i>Hotel Management</Link><br />
                            <Link className='footer-link' to='/mlm-software'><i class="fa-solid fa-angle-right me-2"></i>MLM Software</Link><br />
                            <Link className='footer-link' to='/face-attendance'><i class="fa-solid fa-angle-right me-2"></i>Face Attendance</Link>
                        </div>


                    </div>
                    {/* row ends */}
                    <hr />

                    <div className='d-flex justify-content-between'>
                        <p className='pe-3'>Copyright &copy; Dectwin Services Pvt Ltd</p>
                        <p><Link className='footer-link' to='/privacy-policy'>Privacy Policy</Link>&nbsp;&nbsp;<Link className='footer-link' to='/careers'>Careers</Link>&nbsp;&nbsp;<Link className='footer-link' to='/support'>Support</Link></p>
                    </div>
                </div>
            </footer>

            <button className='whatsapp-btn animate__animated animate__headShake animate__infinite' onClick={() => window.open('https://wa.me/918707510135?text=Hey!%20Dectwin%20Services.%20I%20have%20an%20enquiry.', '_blank')}><i class="fa-brands fa-whatsapp"></i></button>
            <button className='call-btn animate__animated animate__headShake animate__infinite' onClick={() => window.open('tel:8707510135')}><i class="fa-solid fa-headset"></i></button>
        </>
    )
}

export default Footer
